import { Injectable } from '@angular/core';
import { iValidatedControl } from '../../components/ui/controls/iValidatedControl';

@Injectable({
  providedIn: 'root',
})
export class FormValidator {
  public validate(validatedControls: iValidatedControl[]): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    for (var i = 0; validatedControls && i < validatedControls?.length; i++) {
      if (!validatedControls[i].validate()) {
        errors.push(
          new ValidationMessage(
            validatedControls[i].getLabel(),
            validatedControls[i].getValidationMessage(),
          ),
        );
      }
    }

    return errors;
  }
}

export class ValidationMessage {
  public label: string = '';
  public message: string = '';

  constructor(label: string, message: string) {
    this.label = label;
    this.message = message;
  }
}
